import { downloadUrlSettings } from "./DownloadDocument";
import axios from "axios";
import moment from "moment/moment";
import {
    Filter1,
    Filter5,
    Filter6,
    Filter7,
    Filter8,
    Filter9,
    Filter2,
    Filter3,
    Filter4,
    Filter9Plus,
} from "@mui/icons-material";
import secureLocalStorage from "react-secure-storage";

export let parentVal = {
    parent: null,
};

export const allowedTypes =
    ".pdf,image/*,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

const ones = [
    "",
    "one",
    "two",
    "three",
    "four",
    "five",
    "six",
    "seven",
    "eight",
    "nine",
];
const tens = [
    "",
    "",
    "twenty",
    "thirty",
    "forty",
    "fifty",
    "sixty",
    "seventy",
    "eighty",
    "ninety",
];
const teens = [
    "ten",
    "eleven",
    "twelve",
    "thirteen",
    "fourteen",
    "fifteen",
    "sixteen",
    "seventeen",
    "eighteen",
    "nineteen",
];

function convert_millions(num) {
    if (num >= 1000000) {
        return (
            convert_millions(Math.floor(num / 1000000)) +
            " million " +
            convert_thousands(num % 1000000)
        );
    } else {
        return convert_thousands(num);
    }
}

const convert_thousands = (num) => {
    if (num >= 1000) {
        return (
            convert_hundreds(Math.floor(num / 1000)) +
            " thousand " +
            convert_hundreds(num % 1000)
        );
    } else {
        return convert_hundreds(num);
    }
};

const convert_hundreds = (num) => {
    if (num > 99) {
        return ones[Math.floor(num / 100)] + " hundred " + convert_tens(num % 100);
    } else {
        return convert_tens(num);
    }
};

const convert_tens = (num) => {
    if (num < 10) return ones[num];
    else if (num >= 10 && num < 20) return teens[num - 10];
    else {
        return tens[Math.floor(num / 10)] + " " + ones[num % 10];
    }
};

export const convertToWords = (num) => {
    if (num === 0) return "zero";
    else return convert_millions(num);
};

export const range = (start, end) => {
    let foo = [];
    for (let i = start; i <= end; i++) {
        foo.push(i);
    }
    return foo;
};

export const getMonthIcon = (month) => {
    const icons = [
        <Filter1 />,
        <Filter2 />,
        <Filter3 />,
        <Filter4 />,
        <Filter5 />,
        <Filter6 />,
        <Filter7 />,
        <Filter8 />,
        <Filter9 />,
        <Filter9Plus />,
        <Filter9Plus />,
        <Filter9Plus />,
    ];

    return icons[month - 1];
};

export const getMonthName = (month) => {
    const months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
    ];

    return months[month - 1];
};

export const monthList = [
    { name: "January", value: 1 },
    { name: "February", value: 2 },
    { name: "March", value: 3 },
    { name: "April", value: 4 },
    { name: "May", value: 5 },
    { name: "June", value: 6 },
    { name: "July", value: 7 },
    { name: "August", value: 8 },
    { name: "September", value: 9 },
    { name: "October", value: 10 },
    { name: "November", value: 11 },
    { name: "December", value: 12 },
];
export const getMonth = (month) => {
    const selected = monthList.find((item) => item?.value === month);
    return selected?.name;
};
export const getDateList = () => {
    let arr = [];
    for (let i = 1; i <= 31; i++) {
        arr.push(i);
    }

    return arr;
};

export const setFavAndTitle = (settings) => {
    document.title = settings?.systemNameAbr;
    let link = document.querySelector("link[rel~='icon']");
    if (!link) {
        link = document.createElement("link");
        link.rel = "icon";
        document.getElementsByTagName("head")[0].appendChild(link);
    }
    link.href = `${downloadUrlSettings}/${settings?.favicon}`;
};

export const responseInterceptor = (response) => {
    secureLocalStorage.setItem("lastSeen", new Date().toString());
    return response;
};

export const getLoggedUserData = (data) => {
    const {
        Structure,
        behalfId,
        behalf,
        structureId,
        roles,
        userId,
        email,
        role,
        user,
        userInfoId,
        password,
        dn,
        settings,
        Position,
    } = data;

    return {
        userId: userId,
        userInfoId,
        behalf,
        behalfId,
        structureId: structureId,
        roles,
        role,
        dn,
        Position,
        email: email,
        user: { ...user, password, email, Structure },
        settings,
    };
};

const formatY = "DDHHmm";
const formatGlobal = "YYYY-MM-DD";
const formatY2 = "YYYY-MM-DDTHH:mm";

export const getDateKey = (date) => {
    if (date) {
        return moment(date).format(formatY);
    } else {
        return moment().format(formatY);
    }
};

export const getEventValue = (event) => {
    if (typeof event === "string") {
        return event;
    } else if (event?.target?.value) {
        return event?.target?.value;
    } else if (event?.currentTarget?.value) {
        return event?.currentTarget?.value;
    }

    return undefined;
};

export const getDateTime = (date) => {
    return moment(date).format(formatY2);
};

let refreshing = false;
export const errorInterceptor = async (error) => {
    // whatever you want to do with the error
    const url = error?.response?.config?.url;
    const refreshUrl = "/api/user/refresh/token/";
    const refreshToken = secureLocalStorage.getItem("refresh-token");
    const has401 = error?.response?.status === 401 && url !== refreshUrl;
    if (has401 && refreshToken) {
        const lastSeen = secureLocalStorage.getItem("lastSeen");
        if (lastSeen) {
            const diff = moment(new Date()).diff(new Date(lastSeen), "minutes");
            if (diff >= 10) {
                localStorage.clear();
                secureLocalStorage.clear();                
                window.location.href = "/auth/login?not-used-min=10";
                throw error;
            }
        }
        if (!refreshing) {
            refreshing = true;
            try {
                const response = await axios.post(refreshUrl, { token: refreshToken });
                refreshing = false;
                const { data } = response;
                if (data?.accessToken) {
                    secureLocalStorage.setItem("token", data.accessToken);
                    // window.location.reload();
                    const dn = await axios.request(error.response.config);
                    if (dn.data) {
                        return dn;
                    } else {
                        throw error;
                    }
                    // await new Promise(resolve => setTimeout(() => resolve(1000), 100000))
                } else if (response.status === 401) {
                    secureLocalStorage.clear();
                    window.location.href = "/auth/login?refresh=failed";
                }
            } catch (e) {
                if (e?.response?.status === 401) {
                    secureLocalStorage.clear();
                    window.location.href = "/auth/login?refresh=failed";
                }
            }
        } else {
            await new Promise((resolve) => setTimeout(() => resolve(1000), 100000));
            throw error;
        }
    } else if (has401) {
        localStorage.clear();
        secureLocalStorage.clear();
        window.location.href = "/auth/login?expired=true";
    }
    throw error;
};

export const CheckContainDepartment = (name) => {
    return CheckContainDepartmentInner(name, parentVal.parent);
};

export const CheckContainAnyDepartment = (names) => {
    return names.filter((v) => CheckContainDepartment(v)).length > 0;
};

export const CheckContainAnyDepartmentSpecial = (names, myStructureId) => {
    return (
        names.filter(
            (v) =>
                (v.parentId && CheckContainDepartment(v.id)) ||
                innerValidate(v, myStructureId)
        ).length > 0
    );
};

export const CheckMyContainDepartment = (parent2) => {
    let parent = parentVal.parent;
    return CheckContainDepartmentInner(parent?.parent?.id ?? parent?.id, parent2);
};

const innerValidate = (innerParent, name) => {
    return (
        innerParent.name?.toLowerCase() === name ||
        innerParent.id === name ||
        innerParent.proName?.toLowerCase() === name
    );
};

export const CheckContainDepartmentInner = (name, parent) => {
    let innerParent = parent;
    name = `${name}`.toLowerCase();
    while (innerParent != null) {
        if (innerValidate(innerParent, name)) {
            return true;
        }
        innerParent = innerParent.parent;
    }
    return false;
};

export const CheckHasPermission = (code, action) => {
    const userActions = secureLocalStorage.getItem("userMenus");
    return userActions?.filter((v) => v.code === code && v[action])?.length > 0;
};

export const CheckHasAnyPermission = (code) => {
    const userActions = secureLocalStorage.getItem("userMenus");
    return (
        userActions?.filter(
            (v) => v.code === code && (v.create || v.delete || v.update || v.read)
        )?.length > 0
    );
};

export const getJsonNames = (requestJson) => {
    const obj = getJsonValue(requestJson, "names");
    if (!obj.value) {
        const ob = getJsonValue(requestJson, "firstName");
        const ob2 = getJsonValue(requestJson, "lastName");
        return { type: ob.type, label: "Names", value: `${ob.value} ${ob2.value}` };
    }
    return obj;
};

export const getJsonValue = (requestJson, key, formatDate = true) => {
    const data = requestJson[key];
    let value,
        label = key,
        type;
    if (data && typeof data === "object") {
        value = data.value;
        label = data.label;
        type = data.type;
    } else if (typeof data == "string") {
        value = data;
    } else {
        value = data?.toString();
    }

    if (type === "date" && formatDate) {
        value = moment(value).format(formatGlobal);
    } else if (type === "datetime-local" && formatDate) {
        value = moment(value).format(formatY2);
    }
    return { value, label, type };
};

export const getQuery = (key) => {
    const search = window.location.search;
    const params = new URLSearchParams(search);
    return params.get(key);
};
export const isImage = (name) => {
    return isImageExt(name?.split(".")?.pop()?.toLowerCase());
};
export const isImageExt = (name) => {
    return inArray(["jpg", "png", "webp", "jpeg", "gif"], name);
};
export const getFileMime = (name) => {
    let lowerCase = name?.split(".")?.pop()?.toLowerCase();
    return isImageExt(lowerCase)
        ? `image/${lowerCase}`
        : inArray(["pdf"], lowerCase)
            ? "application/pdf"
            : inArray(["mov", "mp4", "mkv", "wmv", "avi", "webm"], lowerCase)
                ? `video/${lowerCase}`
                : "application/octet-stream";
};

export const inArray = (haystack, needle) => {
    if (!haystack) {
        return false;
    }
    return haystack.filter((v) => v === needle).length > 0;
};

const getBase64Code = (charCode) => {
    if (charCode >= base64codes.length) {
        throw new Error("Unable to parse base64 string.");
    }
    const code = base64codes[charCode];
    if (code === 255) {
        throw new Error("Unable to parse base64 string.");
    }
    return code;
};

const base64abc = [
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z",
    "a",
    "b",
    "c",
    "d",
    "e",
    "f",
    "g",
    "h",
    "i",
    "j",
    "k",
    "l",
    "m",
    "n",
    "o",
    "p",
    "q",
    "r",
    "s",
    "t",
    "u",
    "v",
    "w",
    "x",
    "y",
    "z",
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "+",
    "/",
];

const base64codes = [
    255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255,
    255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255,
    255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 62, 255, 255,
    255, 63, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 255, 255, 255, 0, 255, 255,
    255, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
    21, 22, 23, 24, 25, 255, 255, 255, 255, 255, 255, 26, 27, 28, 29, 30, 31, 32,
    33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51,
];

export const bytesToBase64 = (bytes) => {
    let result = "",
        i,
        l = bytes.length;
    for (i = 2; i < l; i += 3) {
        result += base64abc[bytes[i - 2] >> 2];
        result += base64abc[((bytes[i - 2] & 0x03) << 4) | (bytes[i - 1] >> 4)];
        result += base64abc[((bytes[i - 1] & 0x0f) << 2) | (bytes[i] >> 6)];
        result += base64abc[bytes[i] & 0x3f];
    }
    if (i === l + 1) {
        // 1 octet yet to write
        result += base64abc[bytes[i - 2] >> 2];
        result += base64abc[(bytes[i - 2] & 0x03) << 4];
        result += "==";
    }
    if (i === l) {
        // 2 octets yet to write
        result += base64abc[bytes[i - 2] >> 2];
        result += base64abc[((bytes[i - 2] & 0x03) << 4) | (bytes[i - 1] >> 4)];
        result += base64abc[(bytes[i - 1] & 0x0f) << 2];
        result += "=";
    }
    return result;
};

export const base64ToBytes = (str) => {
    if (str.length % 4 !== 0) {
        throw new Error("Unable to parse base64 string.");
    }
    const index = str.indexOf("=");
    if (index !== -1 && index < str.length - 2) {
        throw new Error("Unable to parse base64 string.");
    }
    let missingOctets = str.endsWith("==") ? 2 : str.endsWith("=") ? 1 : 0,
        n = str.length,
        result = new Uint8Array(3 * (n / 4)),
        buffer;
    for (let i = 0, j = 0; i < n; i += 4, j += 3) {
        buffer =
            (getBase64Code(str.charCodeAt(i)) << 18) |
            (getBase64Code(str.charCodeAt(i + 1)) << 12) |
            (getBase64Code(str.charCodeAt(i + 2)) << 6) |
            getBase64Code(str.charCodeAt(i + 3));
        result[j] = buffer >> 16;
        result[j + 1] = (buffer >> 8) & 0xff;
        result[j + 2] = buffer & 0xff;
    }
    return result.subarray(0, result.length - missingOctets);
};

export const base64encode = (str, encoder = new TextEncoder()) => {
    return bytesToBase64(encoder.encode(str));
};

export const base64decode = (str, decoder = new TextDecoder()) => {
    return decoder.decode(base64ToBytes(str));
};

export const getLogoMaster = (settings, loggedUser) => {
    if (!settings) {
        return null;
    }
    const master = settings.masters?.find(
        (v) => v.id === loggedUser?.user?.Structure?.masterLogoId
    );

    if (master) {
        return master.logo;
    }

    return settings.logoImageSecond;
};

export const getMyLineManager = async (loggedUser) => {
    if (!loggedUser || !loggedUser.Resource) return null;

    try {
        const response = await axios.get("/api/role/my-line-managers");
        const managers = response.data?.data || [];

        // console.log("Managers:", managers);
        // const parentStructures = response.data?.parentStructure?.Structures || [];

        // const { structureId } = loggedUser.Resource;

        // let manager = managers.find((m) => m.structureId === structureId);

        // // Linemanagers case
        // if (!manager && parentStructures.length > 0) {
        //   for (const parent of parentStructures) {
        //     manager = managers.find((m) => m.structureId === parent.id);
        //     if (manager) break;
        //   }
        // }

        return managers || null;
    } catch (error) {
        return null;
    }
};
